import axios from "axios";
import { Auth_URL, Auth_URL2, OTP_SERVICE, User_Service_URL } from "../Url";
import HashMap from "hashmap";

var map = new HashMap();
var err;

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const SetLogoutActions = {
  SET_LOGOUT_DETAILS: "SET_LOGOUT_DETAILS",
};

export function setLogoutFlag() {
  return (dispatch) => dispatch(setLogoutFlagg());
}

export function setLogoutFlagg() {
  return {
    type: SetLogoutActions.SET_LOGOUT_DETAILS,
  };
}

export const IsFirstTimeLoginActions = {
  IS_FIRST_TIME_LOGIN: "IS_FIRST_TIME_LOGIN",
  IS_FIRST_TIME_LOGIN_SUCCESS: "IS_FIRST_TIME_LOGIN_SUCCESS",
  IS_FIRST_TIME_LOGIN_ERROR: "IS_FIRST_TIME_LOGIN_ERROR",
  UPDATE_LOGIN_STATUS: "UPDATE_LOGIN_STATUS",
};

export function isFirstTimeLogin(props) {
  const { username } = props;

  let values = {
    username: username,
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/isFirstTimeLogin`,
      params: values,
    })
      .then((response) => {
        dispatch(isFirstTimeLoginRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(isFirstTimeLoginSuccess(response));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(isFirstTimeLoginError(error));
          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          dispatch(isFirstTimeLoginError(err));
          return err;
        } else if (!err.response) {
          dispatch(isFirstTimeLoginError("Internal Server Error!"));
        }
      });
}

export function isFirstTimeLoginRequest() {
  return {
    type: IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN,
    isPosting: true,
  };
}
export function isFirstTimeLoginError(error) {
  return {
    type: IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN_ERROR,
    payload: error,
  };
}

export function isFirstTimeLoginSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN_SUCCESS,
      payload: props,
    });
  };
}

const actions = {
  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_ERROR: "LOGOUT_ERROR",
};

export default actions;

export function login(props) {
  const { state, history, ip } = props;
  let values = {
    username: state.username,
    password: state.password,
    portal: "PARTNER_PORTAL",
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/login`,
      data: values,
      headers: {
        REMOTE_ADDRESS: ip,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(loginError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(loginError(err));
          return err.response;
        }
      });
}

export function loginRequest() {
  return {
    type: actions.LOGIN,
    isPosting: true,
  };
}
export function loginError(error) {
  return {
    type: actions.LOGIN_ERROR,
    payload: error,
  };
}

export function loginSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: actions.LOGIN_SUCCESS,
      payload: props,
    });
  };
}

export function logout(access_token) {
  return (dispatch, getState) =>
    axios({
      method: "post",
      url: `${Auth_URL}/customLogout`,
      headers: {
        Authorization: "Bearer " + getState()?.auth?.idToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(logoutSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(logoutError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(logoutError(err));
          return err.response;
        }
      });
}

export function logoutRequest() {
  return {
    type: actions.LOGOUT_REQUEST,
  };
}
export function logoutError(error) {
  return {
    type: actions.LOGOUT_ERROR,
    payload: error,
  };
}

export function logoutSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: actions.LOGOUT_SUCCESS,
      payload: props,
    });
  };
}

export const IsForgotPasswordActions = {
  IS_FORGOT_PASSWORD: "IS_FORGOT_PASSWORD",
  IS_FORGOT_PASSWORD_SUCCESS: "IS_FORGOT_PASSWORD_SUCCESS",
  IS_FORGOT_PASSWORD_ERROR: "IS_FORGOT_PASSWORD_ERROR",
};

// export const isForgotPassword = (prop) => async (dispatch, getState) => {
//   const { username } = prop;
//   let values = {
//     username: username,
//   };
//   try {
//     dispatch(isForgotPasswordRequest());
//     const response = await axios({
//       method: "post",
//       url: `${Auth_URL}/forgotPassword`,
//       body: values,
//     });
//     if (response.status >= 200 && response.status < 300) {
//       dispatch(isForgotPasswordSuccess(response));
//       return response;
//     } else {
//       const error = new Error(response.statusText);
//       dispatch(isForgotPasswordError(error));
//       throw error;
//     }
//   } catch (error) {
//     dispatch(isForgotPasswordError(error));
//     return error;
//   }
// };

export const isForgotPassword = (props) => {
  const { username } = props;
  let values = {
    username: username,
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/forgotPassword`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(isForgotPasswordSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(isForgotPasswordError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(isForgotPasswordError(err));
          return err.response;
        }
      });
};

export function isForgotPasswordRequest() {
  return {
    type: IsForgotPasswordActions.IS_FORGOT_PASSWORD,
    isForgotPassword: true,
  };
}
export function isForgotPasswordError(error) {
  return {
    type: IsForgotPasswordActions.IS_FORGOT_PASSWORD_ERROR,
    payload: error,
  };
}

export function isForgotPasswordSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: IsForgotPasswordActions.IS_FORGOT_PASSWORD_SUCCESS,
      payload: props,
    });
  };
}

export const ResendOtpActions = {
  RESEND_OTP: "RESEND_OTP",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  RESEND_OTP_ERROR: "RESEND_OTP_ERROR",
};

export const resendOtp = (props) => {
  const { username } = props;
  let values = {
    username: username,
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/resendOTP`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(resendOtpSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(resendOtpError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(resendOtpError(err));
          return err.response;
        }
      });
};

export function resendOtpRequest() {
  return {
    type: ResendOtpActions.RESEND_OTP,
    isPosting: true,
  };
}
export function resendOtpError(error) {
  return {
    type: ResendOtpActions.RESEND_OTP_ERROR,
    payload: error,
  };
}

export function resendOtpSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: ResendOtpActions.RESEND_OTP_SUCCESS,
      payload: props,
    });
  };
}

export const VerifyOtpActions = {
  VERIFY_OTP: "VERIFY_OTP",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
  VERIFY_OTP_ERROR: "VERIFY_OTP_ERROR",
};

export const verifyOtp = (props) => {
  const { username, otp } = props;
  let values = {
    username: username,
    otp: otp,
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/verifyPartnerOtp`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(verifyOtpSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(verifyOtpError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(verifyOtpError(err));
          return err.response;
        }
      });
};

export function verifyOtpRequest() {
  return {
    type: VerifyOtpActions.VERIFY_OTP,
    isPosting: true,
  };
}
export function verifyOtpError(error) {
  return {
    type: VerifyOtpActions.VERIFY_OTP_ERROR,
    payload: error,
  };
}

export function verifyOtpSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: VerifyOtpActions.VERIFY_OTP_SUCCESS,
      payload: props,
    });
  };
}

export const setNewPasswordActions = {
  SET_NEW_PASSWORD: "SET_NEW_PASSWORD",
  SET_NEW_PASSWORD_SUCCESS: "SET_NEW_PASSWORD_SUCCESS",
  SET_NEW_PASSWORD_ERROR: "SET_NEW_PASSWORD_ERROR",
};

export const setNewPassword = (props) => {
  const { VerifyOTPToken, password } = props;
  let values = {
    // username: username,
    newPassword: password,
  };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/setNewPassword`,
      data: values,
      headers: {
        Authorization: `Bearer ${VerifyOTPToken}`,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(setNewPasswordSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(setNewPasswordError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(setNewPasswordError(err));
          return err.response;
        }
      });
};

export function setNewPasswordRequest() {
  return {
    type: setNewPasswordActions.SET_NEW_PASSWORD,
    isPosting: true,
  };
}
export function setNewPasswordError(error) {
  return {
    type: setNewPasswordActions.SET_NEW_PASSWORD_ERROR,
    payload: error,
  };
}

export function setNewPasswordSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: setNewPasswordActions.SET_NEW_PASSWORD_SUCCESS,
      payload: props,
    });
  };
}

export const ChangePasswordActions = {
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_ERROR: "CHANGE_PASSWORD_ERROR",
};

export const changePassword = (props) => {
  const { oldPassword, newPassword } = props;
  let values = {
    oldPassword: oldPassword,
    newPassword: newPassword,
  };
  return (dispatch, getState) =>
    axios({
      method: "post",
      url: `${Auth_URL}/changePassword`,
      data: values,
      headers: {
        Authorization: `Bearer ${getState().auth?.idToken}`,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(changePasswordSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(changePasswordError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(changePasswordError(err));
          return err.response;
        }
      });
};

export function changePasswordRequest() {
  return {
    type: ChangePasswordActions.CHANGE_PASSWORD,
    isPosting: true,
  };
}
export function changePasswordError(error) {
  return {
    type: ChangePasswordActions.CHANGE_PASSWORD_ERROR,
    payload: error,
  };
}

export function changePasswordSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: ChangePasswordActions.CHANGE_PASSWORD_SUCCESS,
      payload: props,
    });
  };
}

// update login status
export const updateLoginStatus = (props) => {
  return {
    type: IsFirstTimeLoginActions.UPDATE_LOGIN_STATUS,
    payload: props,
  };
};
export function optLogin(payload) {
  const { access_token, userName, otpId, otp, transactionId } = payload;
  return async (dispatch) => {
    return await axios({
      method: "post",
      url: `${OTP_SERVICE}/verifyOTPV2?userName=${userName}&otp=${otp}&otpId=${otpId}&transactionId=${transactionId}`,
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(loginError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(loginError(err));
          return err.response;
        }
      });
  };
}
export function resendLoginOTP(props) {
  const { access_token, payload } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${User_Service_URL}/resendOtpForLogin`,
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      data: payload,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(loginError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(loginError(err));
          return err.response;
        }
      });
}
